export default [{
  path: '/skill',
  name: 'skill',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/skill/index')
}]
